import { Component, OnInit, ChangeDetectionStrategy, ChangeDetectorRef, OnDestroy } from '@angular/core';
import { select, Store } from '@ngrx/store';
import { ApplicationState } from '@feature/store/application-store';
import { Observable } from 'rxjs';
import { WidgetComponent } from '@dashboards/components/widget-component/widget-component';
import { ConfirmationService } from 'primeng/api';
import { CreditorAccount } from '@creditor-accounts/models/creditor-account-model';
import { CreditorAccountService } from '@creditor-accounts/services/creditor-account.service';
import { Router, ActivatedRoute } from '@angular/router';
import { RouteContextService } from '@context/services/route-context.service';

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'mojopma-creditor-accounts-widget',
  templateUrl: './creditor-accounts-widget-mojopma.component.html'
})
export class CreditorAccountsWidgetMojoPmaComponent extends WidgetComponent implements OnInit, OnDestroy {

  accounts: Observable<CreditorAccount[]>;

  constructor(
    private readonly router: Router,
    private readonly route: ActivatedRoute,
    protected store: Store<ApplicationState>,
    protected readonly confirmationService: ConfirmationService,
    private readonly creditorAccountService: CreditorAccountService,
    private readonly routeContextService: RouteContextService) {

    super(store, confirmationService);
    const supplierRef = this.routeContextService.getContextFromRoute(this.route).SupplierRef;
    this.accounts = this.creditorAccountService.getCreditorAccountsBySupplierRef(supplierRef);
  }

  ngOnInit(): void {

  }

  ngOnDestroy() {

  }

  onAccountClicked(account: CreditorAccount) {
    const route = `/creditor/${account.Uri}`;
    this.router.navigate([route]);
  }

}
